var _supportedLanguagesWi;
export var createSoundInitialState = {
  selectedType: 'upload',
  name: '',
  description: '',
  file: null
};
export var validSoundTypes = ['audio/wav', 'audio/mp3', 'audio/wma', 'audio/raw', 'audio/mp4', 'audio/ogg', 'audio/x-wav', 'audio/x-pn-wav', 'audio/flac', 'audio/x-flac', 'audio/mpeg'];
export var supportedLanguagesWithVoices = [{
  code: 'ar-AE',
  name: 'Arabic (Gulf)',
  voices: [{
    id: 'Hala',
    gender: 'Female'
  }, {
    id: 'Zayd',
    gender: 'Male'
  }]
}, {
  code: 'nl-BE',
  name: 'Belgian Dutch (Flemish)',
  voices: [{
    id: 'Lisa',
    gender: 'Female'
  }]
}, {
  code: 'ca-ES',
  name: 'Catalan',
  voices: [{
    id: 'Arlet',
    gender: 'Female'
  }]
}, {
  code: 'yue-CN',
  name: 'Chinese (Cantonese)',
  voices: [{
    id: 'Hiujin',
    gender: 'Female'
  }]
}, {
  code: 'cmn-CN',
  name: 'Chinese (Mandarin)',
  voices: [{
    id: 'Zhiyu',
    gender: 'Female'
  }]
}, {
  code: 'da-DK',
  name: 'Danish',
  voices: [{
    id: 'Sofie',
    gender: 'Female'
  }]
}, {
  code: 'nl-NL',
  name: 'Dutch',
  voices: [{
    id: 'Laura',
    gender: 'Female'
  }]
}, {
  code: 'en-AU',
  name: 'English (Australian)',
  voices: [{
    id: 'Olivia',
    gender: 'Female'
  }]
}, {
  code: 'en-GB',
  name: 'English (British)',
  voices: [{
    id: 'Amy',
    gender: 'Female'
  }, {
    id: 'Emma',
    gender: 'Female'
  }, {
    id: 'Brian',
    gender: 'Male'
  }, {
    id: 'Arthur',
    gender: 'Male'
  }]
}, {
  code: 'en-IN',
  name: 'English (Indian)',
  voices: [{
    id: 'Kajal',
    gender: 'Female'
  }]
}, {
  code: 'en-IE',
  name: 'English (Irish)',
  voices: [{
    id: 'Niamh',
    gender: 'Female'
  }]
}, {
  code: 'en-NZ',
  name: 'English (New Zealand)',
  voices: [{
    id: 'Aria',
    gender: 'Female'
  }]
}, {
  code: 'en-ZA',
  name: 'English (South African)',
  voices: [{
    id: 'Ayanda',
    gender: 'Female'
  }]
}, {
  code: 'en-US',
  name: 'English (US)',
  voices: [{
    id: 'Danielle',
    gender: 'Female'
  }, {
    id: 'Gregory',
    gender: 'Male'
  }, {
    id: 'Ivy',
    gender: 'Female (child)'
  }, {
    id: 'Joanna',
    gender: 'Female'
  }, {
    id: 'Kendra',
    gender: 'Female'
  }, {
    id: 'Kimberly',
    gender: 'Female'
  }, {
    id: 'Salli',
    gender: 'Female'
  }, {
    id: 'Joey',
    gender: 'Male'
  }, {
    id: 'Justin',
    gender: 'Male (child)'
  }, {
    id: 'Kevin',
    gender: 'Male (child)'
  }, {
    id: 'Matthew',
    gender: 'Male'
  }, {
    id: 'Ruth',
    gender: 'Female'
  }, {
    id: 'Stephen',
    gender: 'Male'
  }]
}, {
  code: 'fi-FI',
  name: 'Finnish',
  voices: [{
    id: 'Suvi',
    gender: 'Female'
  }]
}, {
  code: 'fr-BE',
  name: 'French (Belgian)',
  voices: [{
    id: 'Isabelle',
    gender: 'Female'
  }]
}, {
  code: 'fr-CA',
  name: 'French (Canadian)',
  voices: [{
    id: 'Gabrielle',
    gender: 'Female'
  }, {
    id: 'Liam',
    gender: 'Male'
  }]
}, {
  code: 'fr-FR',
  name: 'French',
  voices: [{
    id: 'Léa',
    gender: 'Female'
  }, {
    id: 'Rémi',
    gender: 'Male'
  }]
}, {
  code: 'de-DE',
  name: 'German',
  voices: [{
    id: 'Vicki',
    gender: 'Female'
  }, {
    id: 'Daniel',
    gender: 'Male'
  }]
}, {
  code: 'de-AT',
  name: 'German (Austrian)',
  voices: [{
    id: 'Hannah',
    gender: 'Female'
  }]
}, {
  code: 'hi-IN',
  name: 'Hindi',
  voices: [{
    id: 'Kajal',
    gender: 'Female'
  }]
}, {
  code: 'is-IS',
  name: 'Icelandic',
  voices: [{
    id: 'Dóra',
    gender: 'Female'
  }, {
    id: 'Karl',
    gender: 'Male'
  }]
}, {
  code: 'it-IT',
  name: 'Italian',
  voices: [{
    id: 'Bianca',
    gender: 'Female'
  }, {
    id: 'Adriano',
    gender: 'Male'
  }]
}, {
  code: 'ja-JP',
  name: 'Japanese',
  voices: [{
    id: 'Takumi',
    gender: 'Male'
  }, {
    id: 'Kazuha',
    gender: 'Female'
  }, {
    id: 'Tomoko',
    gender: 'Female'
  }]
}, {
  code: 'ko-KR',
  name: 'Korean',
  voices: [{
    id: 'Seoyeon',
    gender: 'Female'
  }]
}, {
  code: 'nb-NO',
  name: 'Norwegian',
  voices: [{
    id: 'Ida',
    gender: 'Female'
  }]
}, {
  code: 'pl-PL',
  name: 'Polish',
  voices: [{
    id: 'Ola',
    gender: 'Female'
  }]
}, {
  code: 'pt-BR',
  name: 'Portuguese (Brazilian)',
  voices: [{
    id: 'Camila',
    gender: 'Female'
  }, {
    id: 'Vitória/Vitoria',
    gender: 'Female'
  }, {
    id: 'Thiago',
    gender: 'Male'
  }]
}, {
  code: 'pt-PT',
  name: 'Portuguese (European)',
  voices: [{
    id: 'Inês/Ines',
    gender: 'Female'
  }]
}, {
  code: 'es-ES',
  name: 'Spanish (European)',
  voices: [{
    id: 'Lucia',
    gender: 'Female'
  }, {
    id: 'Sergio',
    gender: 'Male'
  }]
}, {
  code: 'es-MX',
  name: 'Spanish (Mexican)',
  voices: [{
    id: 'Mia',
    gender: 'Female'
  }, {
    id: 'Andrés',
    gender: 'Male'
  }]
}, {
  code: 'es-US',
  name: 'Spanish (US)',
  voices: [{
    id: 'Lupe',
    gender: 'Female'
  }, {
    id: 'Pedro',
    gender: 'Male'
  }]
}, {
  code: 'sv-SE',
  name: 'Swedish',
  voices: [{
    id: 'Elin',
    gender: 'Female'
  }]
}, {
  code: 'tr-TR',
  name: 'Turkish',
  voices: [{
    id: 'Burcu',
    gender: 'Female'
  }]
}];
var defaultLanguage = 'en-US';
var defaultVoice = ((_supportedLanguagesWi = supportedLanguagesWithVoices.find(function (lang) {
  return lang.code === defaultLanguage;
})) === null || _supportedLanguagesWi === void 0 || (_supportedLanguagesWi = _supportedLanguagesWi.voices[0]) === null || _supportedLanguagesWi === void 0 ? void 0 : _supportedLanguagesWi.id) || '';
export var textToSpeechInitialState = {
  showConfirm: false,
  audioUrl: '',
  audioDuration: 0,
  text: '',
  language: defaultLanguage,
  voice: defaultVoice,
  name: '',
  loading: false
};